import Stack from '@mui/material/Stack';
import { border } from '../utils/theme.js';
import Typography from '@mui/material/Typography';
import { Trans } from 'react-i18next';
import Box from '@mui/material/Box';
import IssuedAt from './icons/IssuedAt.jsx';
import ExpiresAt from './icons/ExpiresAt.jsx';
import { utcDateStringFromNumber } from '../utils/time.js';
import Grid from '@mui/material/Grid';

export default function Validity({ certificate }) {
    return (
        <Box
            sx={{
                ...border,
                borderRadius: 4,
                paddingX: 2,
                paddingY: { xs: 1, md: 2 },
            }}
        >
            <Grid container>
                <Grid spacing={1} size={{ xs: 12, sm: 4 }}>
                    <Stack direction={'row'} spacing={1} sx={{ alignItems: 'center' }}>
                        <IssuedAt />
                        <Typography variant="body11" pr={4}>
                            <Trans
                                i18nKey={'certificate.validity.issued-at'}
                                tOptions={{ interpolation: { escapeValue: false } }}
                                values={{
                                    when: utcDateStringFromNumber(certificate.date),
                                }}
                            />
                        </Typography>
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }} sx={{ mt: { xs: 1, sm: 0 } }}>
                    <Stack direction={'row'} spacing={1} sx={{ alignItems: 'center' }}>
                        <ExpiresAt fill={certificate.expired ? 'Red' : '#1E1E1ECC'} />
                        <Typography variant="body11" color={certificate.expired ? '#D03232CC' : '#1E1E1ECC'}>
                            {certificate.expires && (
                                <Trans
                                    i18nKey={`certificate.validity.${certificate.expired ? 'expired-at' : 'expires-at'}`}
                                    tOptions={{ interpolation: { escapeValue: false } }}
                                    values={{
                                        when: utcDateStringFromNumber(certificate.expires),
                                    }}
                                />
                            )}
                            {!certificate.expires && <Trans i18nKey={'certificate.validity.no-expiration'} />}
                        </Typography>
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    );
}
